import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

//
import { Row } from "react-bootstrap";

//
import PlanItems from "./PlanItems";

function Plans({subscriptions}) {

  return (
    <Row className="plans">
      {subscriptions.map((item, index) => (
        <PlanItems item={item} key={index}/>
      ))}
    </Row>
  );
}

Plans.propTypes = {
  subscriptions: PropTypes.array.isRequired,
};

const mapStateToProps = state => ({
  subscriptions: state.planReducer.subscriptions
})

export default connect(mapStateToProps)(Plans);
